import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00031 1.93294C11.3507 1.93312 14.0667 4.64991 14.0667 8.00032C14.0665 11.3506 11.3506 14.0666 8.00031 14.0667C4.64989 14.0667 1.9331 11.3507 1.93292 8.00032C1.93292 4.6498 4.64978 1.93294 8.00031 1.93294Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.06 5.99999C6.21673 5.55444 6.5261 5.17873 6.9333 4.93942C7.3405 4.7001 7.81926 4.61262 8.28478 4.69247C8.7503 4.77232 9.17254 5.01434 9.47672 5.37568C9.78089 5.73702 9.94737 6.19434 9.94666 6.66666C9.94666 7.99999 7.94666 8.66666 7.94666 8.66666V9.33333"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7.99998" cy="11.3333" r="0.666667" fill="currentColor" />
    </svg>
  ),
  default: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.7998C17.081 2.7998 21.2002 6.91898 21.2002 12C21.2002 17.081 17.081 21.2002 12 21.2002C6.91898 21.2002 2.7998 17.081 2.7998 12C2.7998 6.91898 6.91898 2.7998 12 2.7998Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09003 8.99999C9.32513 8.33166 9.78918 7.7681 10.4 7.40912C11.0108 7.05015 11.7289 6.91893 12.4272 7.0387C13.1255 7.15848 13.7588 7.52151 14.2151 8.06352C14.6714 8.60552 14.9211 9.29151 14.92 9.99999C14.92 12 11.92 13 11.92 13V14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="17" r="1" fill="currentColor" />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.9997 3.66667C22.8111 3.66667 28.3335 9.18831 28.3337 15.9997C28.3337 22.8112 22.8112 28.3337 15.9997 28.3337C9.18833 28.3335 3.66669 22.8111 3.66669 15.9997C3.66686 9.18842 9.18844 3.66684 15.9997 3.66667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1201 12C12.4335 11.1089 13.0523 10.3575 13.8667 9.87883C14.6811 9.4002 15.6386 9.22524 16.5696 9.38493C17.5007 9.54463 18.3451 10.0287 18.9535 10.7514C19.5618 11.474 19.8948 12.3887 19.8934 13.3333C19.8934 16 15.8934 17.3333 15.8934 17.3333V18.6667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16" cy="22.6667" r="1.33333" fill="currentColor" />
    </svg>
  ),
};

function HelpIcon(props: Omit<SvgIconProps, "fontSize"> & { fontSize?: "large" | "small" }) {
  const item = size[props.fontSize || "default"];

  return (
    <SvgIcon {...props} fontSize={props.fontSize}>
      {item}
    </SvgIcon>
  );
}

export default HelpIcon;
